import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from '../../Context/ConfigContext'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { ContentLoader, NoRecords } from "../../Components/Shimmer"
import { DateFormaterMonth } from '../GlobalFunctions'

const AssignedItem = () => {
  const { apiURL, apiHeaderJson } = useContext(ConfigContext)
  const { project_id } = useParams()

  const [loadingList, setLoadingList] = useState(true)
  const [projectselectedItems, setProjectselectedItems] = useState([])

  const getProjectItemList = async () => {
    try {
      setLoadingList(true)
      const response = await axios.get(
        `${apiURL}api/requests/GetProjectItems`,
        {
          params: { project_id },
          headers: apiHeaderJson
        }
      )

      const { data, success } = response.data

      if (success) {
        setProjectselectedItems(data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingList(false)
    }
  }

  useEffect(() => {
    getProjectItemList()
  }, [])

  return (
    <div className="col-xxl-12">
      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">Items List</h5>
        </div>

        <div className="card-body">
          {loadingList ? (
            <ContentLoader />
          ) : projectselectedItems.length === 0 ? (
            <NoRecords />
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th>ID</th>
                    <th>Item Name</th>
                    <th>Price (QAR)</th>
                    <th>Received Quantity</th>
                    <th>Total Quantity</th>
                    <th>Delivery Date</th>
                  </tr>
                </thead>

                <tbody>
                  {projectselectedItems.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.item_name || '-'}</td>
                      <td>{item?.pi_item_price ?? '-'}</td>
                      <td>{item?.pi_item_received_qty ?? '-'}</td>
                      <td>{item?.pi_item_qty ?? '-'}</td>
                      <td>
                        {item?.pi_item_delivery_date
                          ? DateFormaterMonth(item.pi_item_delivery_date)
                          : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AssignedItem
